import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ExpressionStore"*/ "./lazyIndex"), { name: "ExpressionStore" });

export const lazyCloseExpressionPane: LazyAction<typeof lazyIndex.closeExpressionPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.closeExpressionPane);
